<template>
  <div class="boss-main-container">
    <interview-register-form
      @submit="register"
    />
  </div>
</template>

<script>
import InterviewRegisterForm from '@/components/organisms/InterviewRegisterForm'

export default {
  components: {
    InterviewRegisterForm
  },
  methods: {
    register (data) {
      this.$http.secured.post('/interview_countermeasures', data.params)
        .then(response => {
          this.$toasted.global.success({ message: '面接情報を登録しました。' })
          data.isSettings
            ? this.$router.push({ name: 'interviewSettings', params: { interviewCountermeasureId: response.data } })
            : this.$router.push({ name: 'interviewTop' })
        })
    }
  }
}
</script>
